export const messages = {
    headline: {
        defaultMessage: '',
        id: 'nemo.ui.sc.consumption.headline',
    },
    subheadline: {
        nedc: {
            defaultMessage: '',
            id: 'nemo.ui.sc.details.techdata.nefz.headline',
        },
        wltp: {
            defaultMessage: '',
            id: 'nemo.ui.sc.details.techdata.wltp.headline',
        },
        range: {
            id: 'nemo.ui.sc.electrical.range.wltp.headline',
            defaultMessage: '',
        },
        efficiency: {
            defaultMessage: '',
            id: 'nemo.ui.sc.details.techdata.efficiency.headline',
        },
    },
    eecLabel: {
        defaultMessage: '',
        id: 'nemo.ui.sc.details.technical-data.eec.label',
    },
    envkvImageAltNew: {
        defaultMessage: '',
        id: 'nemo.ui.sc.details.envkv.label.new.alt',
    },
    envkvImageAltUsed: {
        defaultMessage: '',
        id: 'nemo.ui.sc.details.envkv.label.used.alt',
    },
    envkvDownloadLabelNew: {
        defaultMessage: '',
        id: 'nemo.ui.sc.details.envkv.download.new.label',
    },
    envkvDownloadLabelUsed: {
        defaultMessage: '',
        id: 'nemo.ui.sc.details.envkv.download.used.label',
    },
    testCycleLabels: {
        nedc: {
            urban: { id: 'nemo.ui.sc.consumption.nefz.urban.label', defaultMessage: '' },
            extraUrban: {
                id: 'nemo.ui.sc.consumption.nefz.extraurban.label',
                defaultMessage: '',
            },
            combined: { id: 'nemo.ui.sc.consumption.nefz.combined.label', defaultMessage: '' },
            plugInCombined: {
                id: 'nemo.ui.sc.consumption.nefz.combined.electrical.label',
                defaultMessage: '',
            },
        },
        wltp: {
            low: { id: 'nemo.ui.sc.consumption.wltp.low.label', defaultMessage: '' },
            medium: { id: 'nemo.ui.sc.consumption.wltp.medium.label', defaultMessage: '' },
            high: { id: 'nemo.ui.sc.consumption.wltp.high.label', defaultMessage: '' },
            extraHigh: {
                id: 'nemo.ui.sc.consumption.wltp.extrahigh.label',
                defaultMessage: '',
            },
            combined: { id: 'nemo.ui.sc.consumption.wltp.combined.label', defaultMessage: '' },
            rangeCity: { id: 'nemo.ui.sc.electrical.range.city.label', defaultMessage: '' },
            rangeCombined: {
                id: 'nemo.ui.sc.electrical.range.combined.label',
                defaultMessage: '',
            },
            plugInCombined: {
                id: 'nemo.ui.sc.consumption.wltp.combined.electrical.label',
                defaultMessage: '',
            },
        },
    },
    emissionEntry: {
        id: 'nemo.ui.sc.technical-data.emissionCombined',
        defaultMessage: '',
    },
    testCycles: {
        wltp: {
            label: { id: 'nemo.ui.sc.wltp.item.label', defaultMessage: '' },
            linkLabel: {
                id: 'nemo.ui.sc.details.techdata.wltp.link.text',
                defaultMessage: '',
            },
        },
        nedc: {
            label: { id: 'nemo.ui.sc.nedc.item.label', defaultMessage: '' },
            linkLabel: {
                id: 'nemo.ui.sc.details.techdata.nefz.link.text',
                defaultMessage: '',
            },
        },
    },
    efficiency: {
        classLabel: {
            id: 'nemo.ui.sc.efficiency.classLabel',
            defaultMessage: '',
        },
        headline: {
            id: 'nemo.ui.sc.emission.headline',
            defaultMessage: '',
        },
        envkvNoteLabel: {
            id: 'nemo.ui.common.note',
            defaultMessage: '',
        },
        envkvNoteText: {
            id: 'nemo.ui.sc.details.technical-data.envkv.note',
            defaultMessage: '',
        },
        eecIntroduction: {
            defaultMessage: '',
            id: 'nemo.ui.sc.details.technical-data.eec.introduction',
        },
        taxDisclaimer: {
            defaultMessage: '',
            id: 'fa.audi-feature-app-tax.tax-disclaimer',
        },
        efficiencyImageDisclaimer: {
            defaultMessage: '',
            id: 'nemo.ui.sc.efficiencyImageDisclaimer',
        },
        nedcDisclaimer: {
            defaultMessage: '',
            id: 'nemo.ui.sc.result.consumption.disclaimer',
        },
    },
};
